var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantageShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 99,
    viewBox: "0 0 60 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5330_3376)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.98492,
    y: 0.484921,
    width: 53.1214,
    height: 91.5542,
    rx: 5.40317,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.469841
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.77148,
    y: 21.8232,
    width: 49.5466,
    height: 49.5514,
    rx: 0.939683,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.77148,
    y: 72.3867,
    width: 15.8414,
    height: 15.843,
    rx: 0.939683,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.625,
    y: 72.3867,
    width: 15.8414,
    height: 15.843,
    rx: 0.939683,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.4746,
    y: 72.3867,
    width: 15.8414,
    height: 15.843,
    rx: 0.939683,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.8652,
    y: 3.2832,
    width: 20.8972,
    height: 2.02251,
    rx: 0.939683,
    fill: "#DDDFE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.8652,
    y: 6.31836,
    width: 9.43745,
    height: 2.02251,
    rx: 0.939683,
    fill: "#DDDFE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.77148,
    y: 11.374,
    width: 48.5355,
    height: 2.02251,
    rx: 0.939683,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.77148,
    y: 14.4072,
    width: 45.502,
    height: 2.0225,
    rx: 0.939683,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.77148,
    y: 17.4414,
    width: 10.1116,
    height: 2.02251,
    rx: 0.939683,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94055 5.47476C9.94055 7.11362 8.61213 8.44214 6.97348 8.44214C5.33483 8.44214 4.00641 7.11362 4.00641 5.47476C4.00641 3.8359 5.33483 2.50738 6.97348 2.50738C8.61213 2.50738 9.94055 3.8359 9.94055 5.47476Z",
    stroke: "currentColor",
    strokeWidth: 0.469841
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5330_3376",
    x: 0.232051,
    y: 0.25,
    width: 59.6636,
    height: 98.0962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.51795,
    dy: 3.0359
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.51795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5330_3376"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5330_3376",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantageShopping);
export default __webpack_public_path__ + "static/media/advantageShopping.5e1e615678dc435bb3e21621d2194b9d.svg";
export { ForwardRef as ReactComponent };